export const defaultStyleValue = () => {
	return {
		width : null,
		height : null,
		bg_color : null,
		font_color : null,
		font_size : null,
		text_align: null,
		x: null,
		y: null,
		title: "",
		margin : null,
		// Border Related
		border_color : null,
		border_width : null
	}
}

const getFormattedValFromKey = function(key, val){
	if(['width', 'height', 'font_size', 'margin', 'border_width'].includes(key)){
		return `${val}px`
	} else if(['text_align'].includes(key)){
		const mapping = { 'L' : 'left', 'R' : 'right', 'C' : 'center' }
		return mapping[val]
	}

	return val
}

export const getCSSFromStyles = function(styles_incoming){
	// Removing styles which havent been filled
	let styles = {}
	for(let style_key in styles_incoming){
		const val = styles_incoming[style_key]
		if(val!==null && val!==undefined && val.toString().length){
			styles[style_key] = val
		}		
	}

	if(!styles) return {} // Return empty object if styles is null or undefined

	// Some formatting for borders
	if(Object.keys(styles).filter(k => ["border_color", "border_width"].includes(k)).length){
		if(styles['border_width']===null || styles['border_width']===undefined || !styles['border_width'].toString().length){
			styles['border_width'] = 1
		}if(!styles['border_color']){
			styles['border_color'] = "#000"
		}if(!styles['border_style']){
			styles['border_style'] = "solid"
		}
	}

	let key_mapping = {
		width : 'width',
		height : 'height',
		bg_color : 'background-color',
		border_color : 'border-color',
		font_color : 'color',
		font_size : 'font-size',
		text_align: 'text-align',
		margin: 'margin',
		border_width : 'border-width',
		border_style : 'border-style'
	}

	let css_styles = {}
	for(let style_key in styles){
		if(key_mapping[style_key]){
			let val = getFormattedValFromKey(style_key, styles[style_key])
			if((styles[style_key] !== undefined) && (styles[style_key] !== undefined)){
				css_styles[key_mapping[style_key]] = val
			}
		}
	}

	return css_styles
}
